/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node,
};

export default class LeftRail extends Component {
    render() {
        return <section className="rec-grid-8-12">{this.props.children}</section>;
    }
}

LeftRail.propTypes = propTypes;
